// extracted by mini-css-extract-plugin
export default {"graphDesktop":"DaysGraph_graphDesktop__2mcRs","graphSm":"DaysGraph_graphSm__soaDq"};